/**
 *  分页模块 biliPager()
 *  能够在某个元素内装载分页组件的模块,有多个可定制的参数，可同时在页面多处使用
 *      
 * （样式皮肤暂时仅提供一个默认样式(仅支持PC端)，与主站评论的分页相同）
 *
 * @author  zero (mengguanjie@bilibili.com)
 * @date    2016-5-16
 * @version 0.1.1
 * 
 * @depend  必要依赖jQuery v1.7.2以上， 建议用主站通用的jQuery：http://static.hdslb.com/js/jquery.min.js 
 */

;(function($){
    'use strict';
    var methods = {
        init: function(options) {
            //  默认参数
            var option = $.extend({
                onTurnPage: function(pageIndex , event) {
                    // 翻页后回调
                },
                onInit: function(pageIndex) {
                    // 初始化回调
                },
                totalItems: 0,  //  总条目数
                pageItems: 10,  //  每页包含的条目数
                showedPages: 5,  //  当前页附近显示几个页码，超过总页数则忽略
                currentPage: 1,  //  初始化时显示为第几页
                edge: 1, //  首页和末页附近显示几个页码，为0时不加入
                addStyle: true,  //  是否在body下加入含有默认皮肤css代码的style标签，具体css代码在src/css/下
                ellipseText: '&hellip;',  // 省略号的自定义文本，为false时不加入省略号元素
                prevText: '上一页',  //  为false时 去掉上一页按钮
                nextText: '下一页',  //  为false时 去掉下一页按钮
                jumpTarget: false,  //  跳页后是否自动滚动至某一元素，例如；'.top'
                showJumper: true,  //  是否给出跳页功能，是时则在尾部加入‘共XX页，跳至__页’及跳转按钮的DOM
                selectOnClick: true,  //  点击后是否自动渲染页码，false则只触发onTurnPage而不自动渲染页码
                nextAtFront: false,  //  为true时下一页按钮前置(默认为在页码之后)
                invertPageOrder: false,  // 页码是否反向排列(从大到小)
                
            }, options || {});
            
            //  计算总页码数
            option.pages = Math.ceil(option.totalItems / option.pageItems) ? Math.ceil(option.totalItems / option.pageItems) : 0;
            
            if (option.currentPage) {
                option.currentPage = option.currentPage - 1;
            }else{
                option.currentPage = !option.invertPageOrder ? 0 : option.pages - 1;
            }
            option.halfDisplayed = (option.showedPages / 2);

            //  对所有传入的对象都进行pager初始化
            $(this).each(function() {
                $(this).addClass('biliPager').data('biliPager', option);
                methods._render.call($(this));
            });

            if (option.addStyle) {
                var defaultStyle = '<style id="biliPager-style">.biliPager{display:block;font-family:Arial;line-height:40px;list-style-type:none;margin:0 0 5px 0;overflow:hidden;padding:0;position:relative;text-align:center;width:1000px}.biliPager .page-li{background-color:#fff;background-image:none;border-radius:4px;border:1px solid #ddd;color:#222;cursor:pointer;display:block;float:left;font-size:14px;height:38px;line-height:38px;margin:0 2px 0 2px;min-width:15px;padding:0;text-align:center}.biliPager .page-li a{color:#222;display:block;height:100%;line-height:38px;min-width:15px;padding:0;padding:0 10px;text-decoration:none}.biliPager .page-li a:hover{color:#fff}.biliPager .page-li span{color:#222;display:block;height:100%;line-height:38px;min-width:15px;padding:0;padding:0 10px;text-decoration:none}.biliPager .page-li:hover{background:#00a1d6;border:solid 1px #00a1d6;color:#fff;transition:.2s all}.biliPager .page-li.current{border-radius:4px;border:solid 1px #00a1d6;cursor:default}.biliPager .current span{background:#00a1d6;border:0;color:#fff}.biliPager .page-li.disabled{display:none}.biliPager .ellipse{border-radius:4px;border:1px solid transparent;display:block;float:left;font-size:14px;font-weight:bold;font-weight:normal;height:38px;line-height:38px;position:relative}.biliPager .ellipse span{padding:0 10px}.biliPager .next span{padding:0 15px}.biliPager .next a{padding:0 15px}.biliPager .prev span{padding:0 15px}.biliPager .prev a{padding:0 15px}.biliPager .pager-jumper{color:#99a2aa;display:block;float:right;font-size:12px;padding:0 2px;position:relative}.biliPager .pager-jumper a{background-color:#fff;background-image:none;border-radius:4px;border:1px solid #ccd0d7;color:#99a2aa;cursor:pointer;font-size:12px;margin-left:5px;padding:5px;text-align:center;text-decoration:none;transition:.2s all}.biliPager .pager-jumper a:before{content:"跳转"}.biliPager .pager-jumper a:hover{background:#00a1d6;border:1px solid #00a1d6;color:#fff}.biliPager .pager-jumper .pager-jumper-input{border-radius:4px;border:1px solid #ccd0d7;box-shadow:none;color:#99a2aa;display:inline-block;font-size:12px;height:24px;line-height:24px;margin-top:7px;outline:0;padding:0 10px;text-align:center;width:30px}.biliPager .pager-jumper .pager-jumper-input:focus{border:1px solid #00a1d6}</style>';
                if (!$('#biliPager-style').length) {
                    $('body').append(defaultStyle);
                }
            }

            //  执行回调
            option.onInit(option.currentPage + 1);
            return $(this);
        },
        _getPages: function(o) {
            var pages = Math.ceil(o.totalItems / o.pageItems);
            return pages || 1;
        },

        _getInterval: function(o) {
            if (!o.showedPages) {
                return {
                    start: 0,
                    end: 0
                }
            }
            return {
                start: Math.ceil(o.currentPage > o.halfDisplayed ? Math.max(Math.min(o.currentPage - o.halfDisplayed, (o.pages - o.showedPages)), 0) : 0),
                end: Math.ceil(o.currentPage > o.halfDisplayed ? Math.min(o.currentPage + o.halfDisplayed, o.pages) : Math.min(o.showedPages, o.pages))
            };
        },

        _turnPage: function(pageIndex, event) {
            var o = this.data('biliPager');
            o.currentPage = pageIndex;
            if (o.selectOnClick) {
                methods._render.call(this);
            }
            if (o.jumpTarget && $(o.jumpTarget)) {
                var targetTop = $(o.jumpTarget).offset().top || '0';
                $('html,body').animate({scrollTop: targetTop},400);
            }
            return o.onTurnPage(pageIndex + 1, event);
        },
        
        _render: function () {

            methods.destroy.call(this);

            var o = $(this).data('biliPager'),
            interval = methods._getInterval(o),
            i;

            // 上一页 + 第一页及邻近 + 省略 + 当前页及邻近 + 省略 + 最后一页及邻近 + 下一页 + 跳页部分

            if (o.prevText) {
                methods._appendItem.call(this, o.currentPage - 1 , {text: o.prevText, classes: 'prev'});
            }

            if (interval.start > 0 && o.edge > 0) {
                var end = Math.min(o.edge, interval.start);
                for (i = 0; i < end; i++) {
                    methods._appendItem.call(this, i);
                }
            }

            if (o.edge && o.edge < interval.start && (interval.start - o.edge != 1) && o.ellipseText ) {
                $(this).append('<li class="disabled ellipse"><span>' + o.ellipseText + '</span></li>');
            } else if (o.edge && (interval.start - o.edge) == 1) {
                methods._appendItem.call(this, o.edge);
            }

            for (i = interval.start; i < interval.end; i++) {
                methods._appendItem.call(this, i);
            }

            if (o.edge && o.pages - o.edge > interval.end && (o.pages - o.edge - interval.end != 1) && o.ellipseText ) {
                $(this).append('<li class="disabled ellipse"><span>' + o.ellipseText + '</span></li>');
            } else if (o.edge && (o.pages - o.edge - interval.end) == 1) {
                methods._appendItem.call(this, interval.end);
            }

            if (interval.end < o.pages && o.edge > 0) {
                var begin = Math.max(o.pages - o.edge, interval.end);
                for (i = begin; i < o.pages; i++) {
                    methods._appendItem.call(this, i);
                }
            }


            if (o.nextText) {
                methods._appendItem.call(this, o.currentPage + 1 , {text: o.nextText, classes: 'next'});
            }

            // 反向显示页码 
            if (o.invertPageOrder) {
                var li = $(this).find('li').not('.next,.prev');
                li.eq(li.length - 1).attr('id','invertPageOrderFlag');
                for(var k = 0; k < li.length; k++) {
                    li.eq(k).attr('id') ? null : li.eq(k).insertAfter('#invertPageOrderFlag');
                }
                $('#invertPageOrderFlag').removeAttr('id');
            }

            if(o.nextAtFront) {
                $(this).find('.next').eq(0).prependTo($(this));
                $(this).find('.prev').eq(0).appendTo($(this));
            }

            if(o.showJumper && o.totalItems > 0) {
                var $jumper = $('<div class="pager-jumper">\
                    <span>共 ' + o.pages + ' 页，跳至</span>\
                    <input type="text" class="pager-jumper-input" maxlength=4/>\
                    <span>页</span>\
                    <a href="javascript:;"></a>\
                    </div>');

                $jumper.find('input').eq(0).on('keydown', function(event) {
                    var pager = $(this).parent().parent('.biliPager');
                    var data = pager.data('biliPager');
                    if(event && event.keyCode == 13) {
                        var _page = $(this).val();
                        if(!(/^[0-9]*$/).test(_page)){  
                            return;
                        }  
                        if (_page < 1) {
                            _page = 1;
                        } else if (_page > data.pages) {
                            _page = data.pages;
                        }
                        methods.turnPage.call(pager, _page , event);
                    }
                });

                $jumper.find('a').eq(0).on('click', function(event) {
                    var pager = $(this).parents('.biliPager');
                    var data = pager.data('biliPager');
                    var _page = $(this).siblings('input').val() - 0 ;
                    if(!_page || typeof _page !== 'number') {return;}
                    if (_page < 1) {
                        _page = 1;
                    } else if (_page > data.pages) {
                        _page = data.pages;
                    }
                    methods.turnPage.call(pager, _page , event);
                });

                this.append($jumper);
            }

            if ( o.totalItems < 1) {
                $(this).children().hide();
            }

        },

        _appendItem: function(pageIndex, opts) {
            var self = this, options, $link, o = self.data('biliPager'), $linkWrapper = $('<li class="page-li" ></li>');

            pageIndex = pageIndex < 0 ? 0 : (pageIndex < o.pages ? pageIndex : o.pages - 1);

            options = {
                text: pageIndex + 1,
                classes: ''
            };

            options = $.extend(options, opts || {});

            if (pageIndex == o.currentPage || o.disabled) {
                if (o.disabled || options.classes === 'prev' || options.classes === 'next') {
                    $linkWrapper.addClass('disabled');
                } else {
                    $linkWrapper.addClass('active');
                }
                $linkWrapper.addClass('current');

                $link = $('<span>' + (options.text) + '</span>');
            } else {
                $link = $('<a href="javascript:;" >' + (options.text) + '</a>');
                
                $link.on('click',function(event){
                    return methods._turnPage.call(self, pageIndex, event);
                });
            }

            if (options.classes) {
                $linkWrapper.addClass(options.classes);
            }


            $linkWrapper.append($link);
            self.append($linkWrapper);
            
        },

        setPage: function(page) {
            if (!this || !this.data('biliPager')) return;
            for (var i = 0; i < this.length ; i++) {
                var o = this.eq(i).data('biliPager');
                o.currentPage = page - 1;
                this.eq(i).data('biliPager', o);
                methods._render.call(this.eq(i));
            }
            return this;
        },

        turnPage: function(page) {
            if (!this || !this.data('biliPager')) return;   
            methods._turnPage.call(this, page - 1);
            return this;
        },

        prevPage: function() {
            if (!this || !this.data('biliPager')) return;   
            var o = this.data('biliPager');
            if (o.currentPage > 0) {
                methods._turnPage.call(this, o.currentPage - 1);
            }
            return this;
        },

        nextPage: function() {
            if (!this || !this.data('biliPager')) return;   
            var o = this.data('biliPager');
            if (o.currentPage < o.pages - 1) {
                methods._turnPage.call(this, o.currentPage + 1);
            }
            return this;
        },

        getPagesCount: function() {
            if (!this || !this.data('biliPager')) return;   
            return this.length > 1 ? this.map(function(){  return $(this).data('biliPager').pages;}).get().concat() : this.data('biliPager').pages;
        },

        getCurrentPage: function () {
            if (!this || !this.data('biliPager')) return;   
            return this.length > 1 ? this.map(function(){  return $(this).data('biliPager').currentPage + 1;}).get().concat() : this.data('biliPager').currentPage + 1;
        },

        getPageItems: function() {
            if (!this || !this.data('biliPager')) return;   
            return this.length > 1 ? this.map(function(){  return $(this).data('biliPager').pageItems;}).get().concat() : this.data('biliPager').pageItems;
        },

        destroy: function(){
            if(this.data('biliPager')) {
                this.empty();
                return this;
            }
        },
    };

    // Zepto data 模块  兼容.data(name,value)方法
    function getData(node, name) {
        var id = node[exp],
        store = id && data[id];
        if (name === undefined) return store || setData(node);
        else {
            if (store) {
                if (name in store) return store[name];
                var camelName = camelize(name);
                if (camelName in store) return store[camelName];
            }
            return dataAttr.call($(node), name);
        }
    }

    function setData(node, name, value) {
        var id = node[exp] || (node[exp] = ++$.uuid),
        store = data[id] || (data[id] = attributeData(node));
        if (name !== undefined) store[camelize(name)] = value;
        return store;
    }

    function attributeData(node) {
        var store = {}
        $.each(node.attributes || emptyArray,
        function(i, attr) {
            if (attr.name.indexOf('data-') == 0) store[camelize(attr.name.replace('data-', ''))] = $.zepto.deserializeValue(attr.value);
        }); return store;
    }
    if (window.Zepto) {
        var data = {},
        dataAttr = $.fn.data,
        camelize = $.camelCase,
        exp = $.expando = 'Zepto' + ( + new Date()),
        emptyArray = [];

        $.fn.data = function(name, value) {
            return value === undefined ? $.isPlainObject(name) ? this.each(function(i, node) {
                $.each(name,
                function(key, value) {
                    setData(node, key, value)
                })
            }) :

            (0 in this ? getData(this[0], name) : undefined) :

            this.each(function() {
                setData(this, name, value)
            })
        }

        $.fn.removeData = function(names) {
            if (typeof names == 'string') names = names.split(/\s+/); return this.each(function() {
                var id = this[exp],
                store = id && data[id];
                if (store) $.each(names || store,
                function(key) {
                    delete store[names ? camelize(this) : key];
                })
            })
        }

        ; ['remove', 'empty'].forEach(function(methodName) {
            var origFn = $.fn[methodName];
            $.fn[methodName] = function() {
                var elements = this.find('*');
                if (methodName === 'remove') elements = elements.add(this);
                elements.removeData();
                return origFn.call(this);
            }
        })
    }

    $.fn.biliPager = function(method) {
        // 传入对象时初始化，传入字符串时调用方法
        if (!method) {
            $.error('BiliPager needs an argument.');
        } else if (methods[method] && method.charAt(0) != '_') {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object') {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' +  method + ' does not exist.');
        }

    };

})(window.jQuery || window.Zepto);


/** WEBPACK FOOTER **
 ** ./src/js/plugins/biliPager.js
 **/